import React from 'react'
import Seo from './common/Seo';
import Hero from './missionVision/Hero';
import Mission from './missionVision/Mission';
import Vision from './missionVision/Vision';
import CoreValues from './missionVision/CoreValues';
import ClosingCTA from './missionVision/ClosingCTA';

const MissionVision = () => {
    return (
        <>
            <Seo
              title="미션 & 비전"
              description="MTST가 나아가는 길 — 데이터로 제조의 가능성을 넓히고, 스마트 제조 생태계의 글로벌 리더가 되는 것을 목표로 합니다."
              path="/mission-vision"
            />
            <Hero/>
            <Mission/>
            <Vision/>
            <CoreValues/>
            <ClosingCTA/>
        </>
    );
}

export default MissionVision
